<template>
	<div>

		<t-text-area
			disabled
			height="500px"
			resize="none"
			:value="messageContents"
		/>

	</div>
</template>

<script>
import formatter from 'xml-formatter';
import { mapGetters } from './store/outbound.store';
export default {
	
	name: 'EdiMessage',

	props: { base64Content: String },
	computed: {
		...mapGetters(['getTransmissionDetails']),
		messageContents() {
			let { messageContents } = this.getTransmissionDetails;
			if (!messageContents)
				return '';

			if (messageContents.charAt(0) === '<')
				return formatter(messageContents);
			return messageContents;
		}
		
		
	}
	
	
};
</script>

<style>

</style>